/** True when a Supabase RPC failed because the function has not been migrated yet. */
export function isMissingRpcError(message: string): boolean {
  return /could not find the function|function .* does not exist/i.test(String(message || ''));
}
